<template>
<div>
  <el-table
    :data="ticketList"
  >
    <el-table-column
      prop="typeText"
      label="工单类型">
    </el-table-column>
    <el-table-column
      prop="byUserId"
      label="用户ID">
    </el-table-column>
    <el-table-column
      label="创建时间">
       <template slot-scope="scope">
        {{scope.row.createTime | moment}}
      </template>
    </el-table-column>
    <el-table-column
      label="状态">
      <template slot-scope="scope">
        <el-tag :type="(scope.row.__status || {}).color">{{(scope.row.__status || {}).text}}</el-tag>
      </template>
    </el-table-column>
    <el-table-column
      label="操作">
      <template slot-scope="scope">
        <el-button 
          type="primary" 
          icon="el-icon-edit" 
          circle
          size="small"
          v-if="scope.row.status === 0 || scope.row.status === 2"
          @click="handleUpdate(scope.row)"
        ></el-button>
        <el-button 
          type="success" 
          icon="el-icon-view" 
          circle
          size="small"
          v-if="scope.row.status === 1 || scope.row.status === 3"
          @click="handleUpdate(scope.row)"
        ></el-button>
      </template>
    </el-table-column>
  </el-table>
  <pagination
    :size="pagination.size"
    :page="pagination.page"
    :total="totalCount"
    @pageChanged="handleCurrentChange"
    >
  </pagination>
  <ticket-detail v-model="selected" @onUpdated="onUpdated"></ticket-detail>
</div>
</template>

<script>
import TicketDetail from '../detail';
import { mapState } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'TicketList',
  data() {
    return {
      selected: null
    };
  },
  components: {
    TicketDetail,
    Pagination
  },
  methods: {
    handleUpdate(selected) {
      this.selected = selected;
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    onUpdated() {
      this.$emit('refresh', { page: 1 });
    }
  },
  computed: {
    ...mapState('loginUserTicket', ['ticketList', 'pagination', 'totalCount'])
  }
};
</script>

<style lang="less" scoped>
</style>
